export const EVENT_NAME = {
  SUCCESS: 'ON_MAP_SUCCESS',
  LOADING: 'ON_MAP_LOADING',
  FAILURE: 'ON_MAP_FAILURE',
}

export const MAXIMUM_ZOOM_LEVEL = 17
